import React from 'react';
import { Typography } from '@mui/material';

/**
 * Sage status template
 */
export const SageStatusTemplate: React.FC<{ sageStatus?: string }> = ({ sageStatus }) => (
  <Typography variant="body2" sx={{ fontSize: '0.8rem' }}>
    {sageStatus || '-'}
  </Typography>
);

export default SageStatusTemplate;
